<template>
<!-- 在线律师 -->
  <div class="homeonline_lawyer text_center">
    <sec-title Text="律师" ac-text="在线" desc-text="最近登录平台服务的律师，服务响应时间更快，更快解决问题" 
	@clickmore = 'clickmore'
	></sec-title>
    <div class=" between"> 
	
	<div v-for="(item, index) in laywerlist" :key="index">
		<lay-item-win class="item"  :item = 'item'></lay-item-win>
	</div>
	 
	 </div>
    <!-- <router-link to="/findLawyers"> -->
		<!-- <div> <view-more  /> </div> -->
	<!-- </router-link> -->
  </div>
</template>

<script>
import layItemWin from "../components/layItemWin";
import secTitle from "../components/secTitle";
import viewMore from "../components/viewMore";
export default {
	data(){
		return{
			laywerlist:[]
		}
	},
  components:{
    secTitle,
    layItemWin,
    viewMore
  },
  created() {
  	this.$http.home.lawyerads({
		ad_id:1,
		limit:5,
		order:'new'
	}).then(res => {
		this.laywerlist = res.data.data
	})
  },
  methods:{
	  clickmore(){
		  this.$router.push('/findLawyers')
	  }
  }
};
</script>

<style lang="scss" scoped>
.homeonline_lawyer {
  width: 1200px;
  margin: 50px auto 0;
  padding-bottom: 50px;
  .item{
    width: 222px;
    height: 314px;
  }

}
</style>